import { RouteObject } from 'react-router-dom';
import { RoutesEnum } from '~/constants/enums';
import AccountInfo from '~/modules/myAccount/pages/AccountDetails';
import AccountDetails from '~/modules/myAccount/pages/AccountDetails/DetailsUpdate';

export const DesktopRoutes: RouteObject[] = [
  { index: true, element: <AccountInfo /> },
  { path: RoutesEnum.UPDATE_NAME, element: <AccountDetails /> },
];

export const MobileRoutes: RouteObject[] = [
  {
    path: RoutesEnum.DETAILS,
    children: [
      { index: true, element: <AccountInfo /> },
      { path: RoutesEnum.UPDATE_NAME, element: <AccountDetails /> },
    ],
  },
];
